module.exports = __webpack_public_path__ + "static/media/call-question.382b1bf5.svg";